<section id="casino-product" class="casino-product {{'class' | translate}}">
  <div class="container">
    <img *ngIf="showAuxiliarBackground" class="water" [attr.src]="'assets.bg-front' | translate" alt="" />

    <div *ngFor="let item of [].constructor(bubbles); let i = index" class="bubble x{{i}}"></div>

    <div class="product flex">
      <div class="game-character">
        <img @fly-left [attr.src]="'assets.character' | translate" alt="" width="1630" height="926" />
        <div @fade class="character_p" *ngIf="showCharacterParagraph">
          <p>{{'character_p' | translate}}</p>
        </div>
      </div>
      <div @fly-right class="login">
        <img class="freespin-logo" *ngIf="showFreespinLogo" [attr.src]="'assets.freespin-logo' | translate" alt="" width="1637" height="923" />
        <app-login></app-login>
      </div>
    </div>
  </div>
</section>
